/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/
import http from "../http-common";

const controller = "/invoice";
const invoiceService = {
    full: async (id,startDate, endDate) => {
        const response = await http.get(`${controller}/full/${id}?start=${startDate}&end=${endDate}&iscsv=false`);
        return response.data;
    }
};
export default invoiceService;